import { TableColumn } from "../../../../components/ModularDataTable/types"
import { Input } from "../../../../components/Input/Input";
import { DinamicPage } from "../dinamyc-pages.types";
import { i18n } from "../../../../translate/i18n";

export const createColumns = ({ switchStatus }: any): TableColumn[] => {
    const columns: TableColumn[] = [
        {
            key: i18n.t(`agregador_dinamic_page.table.image`),
            value: 'shareImage',
            type: 'custom',
            render: (_value: any, row: DinamicPage) => (
                <img src={row.shareImage} style={{ width: `50px`, height: '50px', objectFit: "cover", borderRadius: '10px' }} />

            ),
        },
        {
            key: i18n.t(`agregador_dinamic_page.table.title`),
            value: 'title',
            type: 'text',
        },
        {
            key: i18n.t(`agregador_dinamic_page.table.description`),
            value: 'description',
            type: 'text',
        },
        {
            key: i18n.t(`agregador_dinamic_page.table.slug`),
            value: 'slug',
            type: 'text',
        },
        {
            key: i18n.t(`agregador_dinamic_page.table.grid_qtd`),
            value: 'slug',
            type: 'custom',
            render: (_value: any, row: DinamicPage) => (
                <span className={`badge badge-success flex justify-content-center align-items-center px-5`}>
                    {row.grids.length}
                </span>
            ),
        },
        {
            key: i18n.t(`agregador_dinamic_page.table.status`),
            value: 'status',
            type: 'custom',
            align: 'center',
            render: (_value: any, row: DinamicPage) => (
                <div>
                    <Input
                        value={row.status}
                        checked={row.status}
                        change={(val: boolean) => {
                            switchStatus({ endpoint: 'product', Id: row.id, status: val })
                        }}
                        inputAttr={{ type: 'checkbox' }}
                        checkSwift={true}
                    />
                </div>
            ),
        },
    ]

    return columns
}